import { Pipe, PipeTransform } from '@angular/core';
import { OrderableIngredient } from 'ngx-web-api';

@Pipe({
  name: 'ingredientGroupFilter',
})
export class IngredientGroupFilterPipe implements PipeTransform {
  transform(ingredients: OrderableIngredient[], grouppedIngredientNames?: string[]): OrderableIngredient[] {
    if (grouppedIngredientNames && grouppedIngredientNames.length) {
      return ingredients.filter(ingredient => grouppedIngredientNames.some(ingrName => ingrName === ingredient.name));
    }

    return ingredients;
  }
}
